"use client";

import { Avatar, AvatarFallback, AvatarImage } from "@/components/ui/avatar";
import { Card, CardContent } from "@/components/ui/card";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function OurTeam() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll({
    threshold: 0.1,
    once: true
  });
  const teamMembers = [{
    id: 1,
    name: "Sarah Mitchell",
    role: "Chief Financial Officer",
    bio: "Over 15 years of experience in financial strategy and corporate leadership.",
    avatar: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1542563/img/sarah_mitchell_avatar.png",
    initials: "SM"
  }, {
    id: 2,
    name: "David Chen",
    role: "Senior Tax Consultant",
    bio: "Specialized in international tax compliance and corporate taxation strategies.",
    avatar: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1542563/img/david_chen_avatar.png",
    initials: "DC"
  }, {
    id: 3,
    name: "Emily Rodriguez",
    role: "Audit Manager",
    bio: "Expert in financial audits and risk assessment with a keen eye for detail.",
    avatar: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1542563/img/emily_rodriguez_avatar.png",
    initials: "ER"
  }, {
    id: 4,
    name: "Michael Thompson",
    role: "Business Advisor",
    bio: "Helping businesses grow through strategic financial planning and consulting.",
    avatar: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1542563/img/michael_thompson_avatar.png",
    initials: "MT"
  }, {
    id: 5,
    name: "Jessica Park",
    role: "Payroll Specialist",
    bio: "Ensuring accurate and timely payroll processing for businesses of all sizes.",
    avatar: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1542563/img/jessica_park_avatar.png",
    initials: "JP"
  }, {
    id: 6,
    name: "Robert Kim",
    role: "Bookkeeping Lead",
    bio: "Meticulous bookkeeping professional with expertise in cloud accounting systems.",
    avatar: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1542563/img/robert_kim_avatar.png",
    initials: "RK"
  }];
  return;
}